export const getServices = (t) => [
    { id: 'office', label: t.services.office },
    { id: 'retail', label: t.services.retail },
    { id: 'hospitality', label: t.services.hospitality },
    { id: 'industrial', label: t.services.industrial },
    { id: 'consulting', label: t.services.consulting }
];
